<template>
    <md-dialog md-open-from="#createProj" md-close-to="#createProj" ref="createProj" @open="fixContent" @close="startOver">
        <md-stepper ref="stepper" @completed="closeDialog" v-if="user.active_pay">
            <md-step md-button-continue="CREATE" md-label="CREATE" md-editable>
                <create :project="project"></create>
            </md-step>
            <md-step md-label="COLLABORATORS">
                <collaborators :project="project"></collaborators>
            </md-step>
            <md-step md-label="LAYERS">
                <layers :project="project"></layers>
            </md-step>

        </md-stepper>
        <div v-else>
            <md-dialog-title>Unable to create project</md-dialog-title>

            <md-dialog-content>Free users are not able to create projects.</md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="cancel">Ok</md-button>
            </md-dialog-actions>
        </div>
    </md-dialog>
</template>

<script>
import firebase from 'firebase';
import { mapGetters } from 'vuex';

import Create from '@/modals/create-project/create';
import Layers from '@/modals/create-project/layers';
import Collaborators from '@/modals/create-project/collaborators';
// Sample
import SampleData from '@/sampleData';

const CreateProject = {
    name: 'createProject',
    data: function() {
        return {
            project: SampleData.defaultProject(),
            projectsRef: firebase.database().ref('projects/')
        };
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    methods: {
        open() {
            this.project = SampleData.defaultProject();
            this.$refs.createProj.open();
        },
        closeDialog() {
            const now = new Date();

            if (this.project.fileObject) {
                const pdfDirRef = firebase.storage().ref('pdfs/' + this.project.fileObject.name);
                const newProject = {};

                pdfDirRef.put(this.project.fileObject).then((snap) => {
                    const newProjectRef = this.projectsRef.push();

                    newProject.lastChangedDate = now.toISOString();
                    newProject.id = newProjectRef.key;
                    newProject.title = this.project.title;
                    newProject.version = 0.1;
                    newProject.showVersion = 0.1;
                    newProject.activeVersion = 0.1;
                    newProject.documentUrl = snap.downloadURL;
                    newProject.ownerUID = this.user['.key'];
                    newProject.lastChangedBy = this.user['.key'];

                    newProjectRef.set(newProject);

                    const layersRef = newProjectRef.child('layers');

                    this.project.layers.forEach((layer) => {
                        const newLayerRef = layersRef.push();
                        layer.id = newLayerRef.key;
                        newLayerRef.set(layer);
                    });

                    const collabsRef = newProjectRef.child('collaborators');

                    this.project.collaborators.forEach((collab) => {
                        collab.layers = {};
                        this.project.layers.forEach((layer) => {
                            collab.layers[layer.id] = false;
                        });
                        collabsRef.child(`${collab.uid}`).set(collab);
                    });
                });
            } else {
                console.log('Could not create project: No File Selected');
            }
            this.$refs.createProj.close();
        },
        fixContent() {
            // console.log('fixing Content');
            if (this.$refs.stepper) {
                this.$nextTick(() => {
                    this.$refs.stepper.calculateStepsWidthAndPosition();
                });
            }
        },
        startOver() {
            if (this.$refs.stepper) {
                this.$refs.stepper.movePreviousStep();
                this.$refs.stepper.movePreviousStep();
            }
        },
        cancel() {
            this.$refs.createProj.close();
        }
    },
    components: {
        create: Create,
        layers: Layers,
        collaborators: Collaborators
    }
};
export default CreateProject;
</script>

<style>
.md-dialog {
    min-width: 400px;
}
</style>


// WEBPACK FOOTER //
// create-project.vue?a43a6af0